import { render, staticRenderFns } from "./orderPerRotation.vue?vue&type=template&id=71cf586a&scoped=true"
import script from "./orderPerRotation.vue?vue&type=script&lang=js"
export * from "./orderPerRotation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cf586a",
  null
  
)

export default component.exports